import {useAddToCartOffCanvas, useCartStatus} from "../../../../redux/stateHooks";
import {Col, Form, InputGroup, Row} from "react-bootstrap";
import {currencyFormatter} from "../../../../utils/helpers";
import * as React from "react";
import {AddToCartItemDetailsModel} from "../../../../models/domain/addToCartDetailsModel";
import {useCustomerArtworkQuery} from "../../../../hooks/useCustomerArtworkQuery";

export function AddToCartItemDetails() {
    const {product} = useAddToCartOffCanvas()
    const image = product?.media.images.dot4b[0];
    const {model: {isTextOnly}} = useCustomerArtworkQuery();

    // Cart data will change when a new item is added.
    // However, for things like dynamic dimensions, artwork and services, the data may not change.
    const cart = useCartStatus();

    // The request data will always be cleared before an item is added
    // Use this for things like dynamic dimensions, artwork and services
    const request = cart.request;

    // A model to drive the more complicated messaging
    const model = cart && product ? new AddToCartItemDetailsModel(product, cart) : undefined;

    // Concatenate the variant attributes into a single string
    const attributes = product?.variantAttributes.concatenate;

    return <Row className="d-flex justify-content-between align-items-start flex-wrap pb-3">
        <Col xs={2} sm={3}>
            {image && image.url &&
                <div className="img-thumbnail border-0" aria-hidden="true">
                    <img src={image.url} alt="" className="img-fluid"/>
                </div>}
        </Col>
        <Col xs={10} sm={9} className="d-flex flex-column h-100 ps-0 justify-content-between">
            <Row>
                <Col xs={9}>
                    {product?.sku && <small className="fw-bold">{product?.sku}</small>}
                    {product?.title && <div>{product?.title}</div>}
                    {request && request.width && request.height &&
                        <div>Width: {request.width}'', Height: {request.height}''</div>}
                    {attributes && <div className="d-flex flex-wrap mt-1">
                        <div>
                            <small className="d-block text-muted">
                                {attributes}
                            </small>
                        </div>
                    </div>
                    }
                    {request && request.artworkName && <div className="dont-break-out">
                        <small className="d-block">
                            <strong className="me-1">Artwork:</strong>
                            {request.artworkName}
                        </small>
                    </div>
                    }
                    {request && isTextOnly && request.artworkNotes && model && model.artworkNotesMessage && <div>
                        <small className="d-block">
                            <strong>{model.artworkNotesMessage}</strong> {' '}
                            {request.artworkNotes}
                        </small>
                    </div>
                    }
                </Col>
            </Row>
            <div className="pt-2 d-flex align-items-center">

                {cart && cart.cartItemQuantity &&
                    <InputGroup className="d-flex align-items-center">
                        <Form.Label htmlFor="quantity"
                                    className="me-2 mb-0 fw-bold">Quantity in Cart:</Form.Label>
                        {cart.cartItemQuantity}
                    </InputGroup>}

                {cart && cart.cartItemPrice &&

                    <div style={{fontSize: '1rem'}}>{currencyFormatter.format(cart.cartItemPrice)}</div>
                }
            </div>

        </Col>
        <Col>
            {model && model.backOrderMessage}
        </Col>
    </Row>;
}